import type { UpdateNotificationSettings200DeliverySettings } from './updateNotificationSettings200DeliverySettings';
import type { UpdateNotificationSettings200TypeSettings } from './updateNotificationSettings200TypeSettings';

/**
 * 알림 설정 응답 데이터
 */
export type UpdateNotificationSettings200 = {
  /** 알림 전달 설정 */
  deliverySettings?: UpdateNotificationSettings200DeliverySettings;
  /** 알림 유형별 설정 */
  typeSettings?: UpdateNotificationSettings200TypeSettings;
  /** 사용자 ID */
  userId: number;
};
